import { render, staticRenderFns } from "./EventoConfig.vue?vue&type=template&id=0ab09460"
import script from "./EventoConfig.vue?vue&type=script&setup=true&lang=js"
export * from "./EventoConfig.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports